// eslint-disable-next-line import/prefer-default-export
export const isLoadingSelector = state => state.submissionForm.get('isLoading');
export const isSubmitedSelector = state => state.submissionForm.get('isSubmited');
export const formErrorsSelector = state => state.submissionForm.get('errors');
